import React, { useMemo } from "react";
import { Select } from "../controls";
import { useMediumsByCategory, sortOthersLast } from "../hooks/queries";

const MediumDropdown = ({
  categoryId,
  name,
  value,
  onChange,
  onClick,
}: any) => {
  const { data = [] } = useMediumsByCategory(categoryId);
  const cats = useMemo(
    () => sortOthersLast(data).map((k: any) => ({ label: k?.name, value: k?._id })),
    [data]
  );

  return (
    <Select
      name={name}
      title="Choose..."
      options={cats}
      showFirstOption={true}
      value={value}
      onChange={onChange}
      onClick={onClick}
    />
  );
};

export default MediumDropdown;
